import jwtDecode from 'jwt-decode';
import { IUserDataToken } from './types';

export const isTokenExpired = (token: string | null) => {
    if (!token) return true;
    const userToken: IUserDataToken = jwtDecode(token);
    const actualDateInMMiliseconds = Math.floor(Date.now() / 1000);
    return actualDateInMMiliseconds >= Number(userToken.exp);
};
